var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-5ccuhh",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29412 4C4.91557 4 3 5.90646 3 8.18823V12.5118C3 14.7935 4.91557 16.7 7.29412 16.7H8.88235V20.1773L12.7964 16.7H16.7059C19.0844 16.7 21 14.7935 21 12.5118V8.18823C21 5.90646 19.0844 4 16.7059 4H7.29412ZM1 8.18823C1 4.76413 3.84914 2 7.29412 2H16.7059C20.1509 2 23 4.76413 23 8.18823V12.5118C23 15.9359 20.1509 18.7 16.7059 18.7H13.5565L9.61895 22.1982C9.1341 22.6243 8.45164 22.7336 7.85434 22.4649C7.2659 22.2001 6.88235 21.6233 6.88235 20.9647V18.6868C3.62503 18.4771 1 15.7984 1 12.5118V8.18823Z",
    fill: "white",
    className: "Ui-fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.98b7982ae8275e92c0247da29cb53262.svg";
export { ForwardRef as ReactComponent };